import React, { useEffect, useState, useRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { useAnalytics } from "../../../providers/AnalyticsProvider";
import { sendEvent, MINIMUM_IMPRESSION_TIME, MINIMUM_THRESHOLD } from "../../../functional/analyticsUtils";
export const TelemetryImpression = ({ impressionEvent, analyticsData, intersectionObserverOptions, asChild = false, children, ...props }) => {
    const { page, blade, uiLocation } = useAnalytics();
    const [elem, setElem] = useState(null);
    const TelemmetryImpressionSent = useRef(false);
    const visibilityTimer = useRef(null);
    const isCurrentlyVisible = useRef(false);
    const ref = (node) => {
        if (node !== null) {
            setElem(node);
        }
    };
    useEffect(() => {
        if (!elem || TelemmetryImpressionSent.current) {
            return;
        }
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    isCurrentlyVisible.current = true;
                    visibilityTimer.current = setTimeout(() => {
                        if (isCurrentlyVisible.current && !TelemmetryImpressionSent.current) {
                            sendEvent(impressionEvent, {
                                page,
                                blade,
                                uiLocation,
                                ...analyticsData,
                            });
                            if (observer) {
                                observer.disconnect();
                                TelemmetryImpressionSent.current = true;
                            }
                        }
                    }, MINIMUM_IMPRESSION_TIME);
                }
                else {
                    isCurrentlyVisible.current = false;
                    if (visibilityTimer.current) {
                        clearTimeout(visibilityTimer.current);
                    }
                }
            });
        }, { threshold: MINIMUM_THRESHOLD, ...intersectionObserverOptions });
        observer.observe(elem);
        return () => {
            observer.disconnect();
        };
    }, [impressionEvent, analyticsData, intersectionObserverOptions, blade, page, uiLocation, elem]);
    const WrapperComponent = asChild ? Slot : "span";
    return (React.createElement(WrapperComponent, { ref: ref, ...props }, children));
};
//# sourceMappingURL=TelemetryImpression.js.map